import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { TemplateType, TemplateConfig } from './types';
import { PreviewLink } from './TemplatePreview';

// Dynamically import RowPreviewButton with SSR disabled
const RowPreviewButton = dynamic(() => import('./RowPreviewButton'), {
  ssr: false,
  loading: () => null,
});

interface ClientOnlyRowPreviewButtonProps {
  pageUrl: string;
  pageTitle: string;
  moduleId?: string;
  template: TemplateType | null;
  config: TemplateConfig;
  links: PreviewLink[];
  visible?: boolean;
}

/**
 * Client-side only wrapper for RowPreviewButton to prevent hydration mismatches.
 * This component only renders after the initial client-side hydration is complete.
 */
export const ClientOnlyRowPreviewButton: React.FC<ClientOnlyRowPreviewButtonProps> = ({
  pageUrl,
  pageTitle,
  moduleId,
  template,
  config,
  links,
  visible = false,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Don't render anything on server or before hydration completes
  if (!isMounted || !template) {
    return null;
  }

  return (
    <RowPreviewButton
      pageUrl={pageUrl}
      pageTitle={pageTitle}
      moduleId={moduleId}
      template={template}
      config={config}
      links={links}
      visible={visible}
    />
  );
};

export default ClientOnlyRowPreviewButton;
